import { toastr } from 'react-redux-toastr';
import adminRestoreDeletedRideBooking from './adminRestoreDeletedRideBooking.gql';
import {
  RESTORE_BOOKING_START,
  RESTORE_BOOKING_SUCCESS,
  RESTORE_BOOKING_ERROR
} from '../../../constants';

export default function restoreDeletedRideBooking(bookingId) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: RESTORE_BOOKING_START
    });

    try {
      const { data } = await client.mutate({
        mutation: adminRestoreDeletedRideBooking,
        variables: {
          bookingId
        }
      });

      if (data?.adminRestoreDeletedRideBooking?.status === 200) {
        dispatch({
          type: RESTORE_BOOKING_SUCCESS
        });
        toastr.success('Success', 'The ride booking has been restored.');
        return {
          status: 200
        };
      }

      dispatch({
        type: RESTORE_BOOKING_ERROR
      });
      toastr.error('Error!', data?.adminRestoreDeletedRideBooking?.errorMessage || 'Oops! Something went wrong. Please try again.');
      return {
        status: 400
      };
    } catch (err) {
      toastr.error('Error!', err);
      dispatch({
        type: RESTORE_BOOKING_ERROR
      });
      return {
        status: 400
      };
    }
  }
};
